import '../../css/custom-responsive.css';
import '../../css/custom.css';
import { useEffect, useState } from 'react';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import sub4 from '../../images/sub-4.png';
import CardNetworkSelection from './marketplaceCard';
import Urls from '../../utils/urls';
import { prefixPath } from '../../utils/helpers';
import apiBackendInstance from '../../utils/axios';
import Button from '../common/buttons/Button';
import CardNetworkNew from './marketplaceContactUsCard';

export interface ProtocolInterface {
  id: string,
  name: string,
  description: string,
  logo_path: string,
  frontend_base_suburl: string,
  subscription_link: string,
  enabled: boolean,
  protocol_type: string,
}

export interface AdditionalProtocolInterface {
  id: string,
  name: string,
  description: string,
  logo_path: string,
  icon_path: string,
  protocol_type: string,
  plan_code: string,
}

const MarketplaceBody = () => {
  const paths = [{ name: 'Dashboard', path: prefixPath('/dashboard') }];
  localStorage.setItem('market_place_source', 'marketplace');
  useEffect(() => {
    let isActive = true;
    showLoader();
    apiBackendInstance.get(Urls.getProtocolList('dedicated'), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && isActive && response.data && response.data.data) {
        const publicArr: ProtocolInterface[] = [];
        const privateArr: ProtocolInterface[] = [];
        const arr = response.data.data;
        for (let i = 0; i < arr.length; i += 1) {
          if (arr[i].protocol_type === 'public') {
            publicArr.push(arr[i]);
          } else if (arr[i].protocol_type === 'hybrid') {
            publicArr.push(arr[i]);
            privateArr.push(arr[i]);
          } else {
            privateArr.push(arr[i]);
          }
        }
        setProtocolData(privateArr);
        setPublicProtocolData(publicArr);
      }
      hideLoader();
    }).catch(() => {
      setProtocolData([]);
      setPublicProtocolData([]);
      hideLoader();
    });
    apiBackendInstance.get(Urls.getAdditionalProtocolList()).then((resp) => {
      if (resp.data.success) {
        setAdditionalPublicProtocolData(resp.data.data);
      }
    }).catch(() => {
      setAdditionalPublicProtocolData([]);
    });
    return () => { isActive = false; };
  }, []);

  const [protocolData, setProtocolData] = useState<ProtocolInterface[]>([
  ]);
  const [publicProtocolData, setPublicProtocolData] = useState<ProtocolInterface[]>([
  ]);
  const [additionalPublicProtocolData, setAdditionalPublicProtocolData] = useState<AdditionalProtocolInterface[]>([]);

  const showLoader = () => {
    const spinner = document.getElementById('spinnerDiv');
    if (spinner) spinner.style.display = 'block';
  };
  const hideLoader = () => {
    const spinner = document.getElementById('spinnerDiv');
    if (spinner) spinner.style.display = 'none';
  };

  const loaderUrl = window.location.origin + prefixPath('/img/zeeve/spin.svg');
  /** usestate for activeTab  for permissive and public  */
  const [activeTab, setActiveTab] = useState('public');
  /** function to handle public key */
  const handleTabPublic = () => {
    setActiveTab('public');
  };
  /** function to handle permissive key */

  const handleTabPermissive = () => {
    setActiveTab('permissive');
  };
  return (
    <section className="px-5 col-12 workspace">
      <div className=" mt-3">
        <div className="col-lg-3 col-xl-6 col-sm-12 col-xs-12 cursor">
          <div className="mt-3 breadcrumb-item  all-color">
            <span className="mx-1 text-black fw-bold" style={{ fontSize: '19px' }}>Full Nodes Marketplace</span>
            <span style={{ fontSize: '17px' }}>- Find Your Protocol To Subscribe</span>
          </div>
          <div className="mx-1 text-black">
            <span className="mx-2 breadcrumb-item  text-black" style={{ fontSize: '12px' }}><Breadcrumb prefixLink={paths} activeLink="Full Nodes" /></span>
          </div>
        </div>
        {/* network list starts here */}
        <div className="card mt-5">
          <div className="card-body">
            <div className="col-11 mx-auto">
              <div className="row">
                  {publicProtocolData.map((p, idx) => (
                      <CardNetworkSelection type="dedicated" num={idx} key={p.id} {...p} />
                  ))}
                  {additionalPublicProtocolData.map((p, idx) => (
                    <CardNetworkNew type="dedicated" num={idx} key={p.id} {...p} />
                  ))}
                <div
                  id="spinnerDiv"
                  className="text-center mx-5 p-3 col-11 "
                  style={{
                    zIndex: 9999, display: 'none', position: 'absolute', marginTop: '26%',
                  }}
                >
                  <img className="" style={{ margin: 'auto' }} src={loaderUrl} alt="spinnner" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default MarketplaceBody;
